exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-045161de]{font-family:Manrope!important}.login-main-wrapper[data-v-045161de],[data-v-045161de]{background-color:#FFFF!important}.login-main-container[data-v-045161de]{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;margin:0 auto!important;-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-045161de","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/wl-auth/index.vue
// module id = MpSo
// module chunks = 0